var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmsFraudSvg = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 15,
  viewBox: "0 0 14 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_12111_26804)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_12111_26804)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.3441 7.2127V2.2527C11.3441 1.56786 10.7889 1.0127 10.1041 1.0127H3.90406C3.21923 1.0127 2.66406 1.56786 2.66406 2.2527V12.1727C2.66406 12.8575 3.21923 13.4127 3.90406 13.4127H6.00406",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_i_12111_26804)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.5207 11.3206V10.154C11.5207 9.50964 10.9988 8.9873 10.3549 8.9873C9.71111 8.9873 9.18919 9.50964 9.18919 10.154V11.3206M9.08927 13.9873H11.6206C11.9937 13.9873 12.1802 13.9873 12.3227 13.9146C12.4481 13.8507 12.5499 13.7488 12.6138 13.6233C12.6864 13.4807 12.6864 13.294 12.6864 12.9206V12.3873C12.6864 12.0139 12.6864 11.8272 12.6138 11.6846C12.5499 11.5592 12.4481 11.4572 12.3227 11.3933C12.1802 11.3206 11.9937 11.3206 11.6206 11.3206H9.08927C8.71616 11.3206 8.52964 11.3206 8.38715 11.3933C8.26178 11.4572 8.15993 11.5592 8.09605 11.6846C8.02344 11.8272 8.02344 12.0139 8.02344 12.3873V12.9206C8.02344 13.294 8.02344 13.4807 8.09605 13.6233C8.15993 13.7488 8.26178 13.8507 8.38715 13.9146C8.52964 13.9873 8.71616 13.9873 9.08927 13.9873Z",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_12111_26804",
  x: 2.16406,
  y: 0.512695,
  width: 10.6797,
  height: 14.4004,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12111_26804"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i_12111_26804",
  x: 7.52344,
  y: 8.4873,
  width: 6.66406,
  height: 7,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12111_26804"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_12111_26804"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "white",
  transform: "translate(0 0.5)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmsFraudSvg);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";